const Disposition = {
  install (Vue, options = {}) {
    Vue.prototype.$disposition = {
      // Init data
      init: function (vm) {
        vm.disposition = this.get(vm)
      },
      // Get disposition
      get: function (vm) {
        let disposition = vm.$session.get('disposition')
        if (!disposition) {
          disposition = {}
        }
        return disposition
      },
      getByKey: function (vm, key, value) {
        let disposition = this.get(vm)
        if (typeof disposition[key] !== 'undefined') {
          let data = disposition[key]
          if (key == 'collectionTimeText') {
            let times = data.split(' ')
            if (times.length > 1) {
              data = times[0] + ' ' + times[1]
            }
          }

          return data
        } else if (value) {
          return value
        }
        return ''
      },
      // Remove session
      remove: function (vm) {
        vm.$session.remove('disposition')
        console.log(this.get(vm))
        vm.disposition = this.get(vm)
      },
      // Set Disposition
      set: function (vm, info) {
        vm.$session.set('disposition', info)
        vm.disposition = this.get(vm)

        // Setup auto trigger clear disposition session after 0:00PM
        let expiredTime = this.calculateExpired(vm)
        vm.$cookie.set('disposition', 1, {
          expires: expiredTime + 'm'
        })
      },
      // Calculate expiration time
      calculateExpired: function (vm) {
        let now = vm.$moment()
        let currentTime = vm.$moment().format('DD/MM/YYYY HH:mm:ss')
        let endDayTime = now.endOf('day').format('DD/MM/YYYY HH:mm:ss')

        let ms = vm.$moment(endDayTime, 'DD/MM/YYYY HH:mm:ss').diff(vm.$moment(currentTime, 'DD/MM/YYYY HH:mm:ss'))
        let d = vm.$moment.duration(ms).asMinutes()

        return d
      }

    }
  }
}
export default Disposition



// WEBPACK FOOTER //
// ./src/plugins/disposition.js